import { render, staticRenderFns } from "./ClassStudentList.vue?vue&type=template&id=87016bba&scoped=true"
import script from "./ClassStudentList.vue?vue&type=script&lang=js"
export * from "./ClassStudentList.vue?vue&type=script&lang=js"
import style0 from "./ClassStudentList.vue?vue&type=style&index=0&id=87016bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87016bba",
  null
  
)

export default component.exports